import axios from 'axios'
import { setInterceptors } from './interceptors'
let token = localStorage.getItem('token')
axios.defaults.withCredentials = true;
axios.defaults.headers = {
  "Access-Control-Allow-Origin": "*",
  'cjjy-token': token,
  Accept: "*/*",
  "request-type": "AJAX"
};
const config = {
  withCredentials: true,//跨域是否使用凭证
  baseURL:'/api'
};
const axiosInstance = axios.create(config)
setInterceptors(axiosInstance)

export default axiosInstance


// WEBPACK FOOTER //
// ./src/http/index.js